(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-youtube"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ggg-latest-youtube')) {
    customElements.define('ggg-latest-youtube', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.loadLatest();
      }
      disconnectedCallback() { this.controller.abort(); }
      async loadLatest() {
        const key = this.dataset.key;
        if (!key) return;
        const cacheKey = 'ggg-youtube-v1-' + this.dataset.playlist;
        try {
          let cached;
          try { cached = JSON.parse(sessionStorage.getItem(cacheKey)); } catch (_) {}
          if (cached && Date.now() - cached.time < 900000 && this.valid(cached.video)) {
            this.renderVideo(cached.video);
            return;
          }
          const url = new URL('https://www.googleapis.com/youtube/v3/playlistItems');
          url.search = new URLSearchParams({ part: 'snippet', playlistId: this.dataset.playlist, maxResults: '1', key }).toString();
          const response = await fetch(url, { signal: this.controller.signal, referrerPolicy: 'strict-origin-when-cross-origin' });
          if (!response.ok) throw new Error('YouTube unavailable');
          const result = await response.json();
          const snippet = result.items?.[0]?.snippet;
          const video = { id: snippet?.resourceId?.videoId, title: snippet?.title };
          if (!this.valid(video)) throw new Error('No public upload');
          if (!this.isConnected) return;
          this.renderVideo(video);
          try { sessionStorage.setItem(cacheKey, JSON.stringify({ time: Date.now(), video })); } catch (_) {}
        } catch (_) {
          this.querySelector('.ggg-youtube__player').hidden = true;
          this.querySelector('.ggg-youtube__title').hidden = true;
        }
      }
      valid(video) { return video && /^[A-Za-z0-9_-]{11}$/.test(video.id) && typeof video.title === 'string'; }
      renderVideo(video) {
        const player = this.querySelector('.ggg-youtube__player');
        const title = this.querySelector('.ggg-youtube__title');
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', this.dataset.playLabel + ': ' + video.title);
        const image = document.createElement('img');
        image.src = 'https://i.ytimg.com/vi/' + video.id + '/hqdefault.jpg';
        image.alt = '';
        image.width = 480;
        image.height = 360;
        image.loading = 'lazy';
        const icon = document.createElement('span');
        icon.className = 'ggg-youtube__play';
        icon.textContent = '▶';
        icon.setAttribute('aria-hidden', 'true');
        button.append(image, icon);
        button.addEventListener('click', () => {
          const iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + video.id + '?autoplay=1&playsinline=1&rel=0';
          iframe.title = video.title;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          player.replaceChildren(iframe);
          iframe.focus();
        }, { once: true });
        player.replaceChildren(button);
        player.hidden = false;
        title.textContent = video.title;
        title.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
